<template>
  <div>
    <Lottie class="loud" :options="options" scale="1" />
  </div>
</template>

<script>
import Lottie from "./Lottie";

export default {
  components: {
    Lottie
  },
  data: function() {
    return {
      options: {
        path: "loud/data.json",
        autoplay: true,
        loop: true
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.loud {
  width: 189px;
  height: 179px;
}

@media (max-width: 1023px) {
  .loud {
    width: 80px !important;
    height: 80px !important;
  }
}
</style>
